import Vue from "vue";

Vue.component("related-trade-concerns", {
	props: ["documentSymbol", "isReference"],
	data() {
		return {
			relatedTradeConcerns: [],
			loading: true
		};
	},
	computed: {
		relatedNotificationsLabel() {
			return htmlEntity.decode(window.labels.relatedTradeConcerns);
		},
		tradeConcernsDetailsUrl() {
			return window.relatedTradeConcernLink;	
		},
		relatedSpecificTradeConcerns() {
			return htmlEntity.decode(window.labels.relatedSpecificTradeConcerns);
		},
		loadingText() {
			return window.labels.loading + "..";
		},
	},
	methods: {
		showViewNotification: function(){
			this.$emit('view-notification', this.documentSymbol);
		}
	},
	mounted() {
		this.loading = true;
		this.$services.tradeConcerns.getRelated({
			documentSymbol: this.documentSymbol ? this.documentSymbol.trim() : ''
		})
			.then((data) => {
				this.loading = false;
				this.relatedTradeConcerns = data;
			});
	},
	template: `
      <div>
      	<div v-if="loading">
	        <loading :loading-text="loadingText"></loading>
      	</div>
      	<div v-else-if="relatedTradeConcerns && relatedTradeConcerns.length > 0" class="column is-full pt-0 pb-1 pl-0">
		  <div v-if="!isReference">
			  <strong>{{ relatedNotificationsLabel }}</strong>:
			  <a v-for="(relatedTradeConcern, index)  in relatedTradeConcerns" v-bind:key="relatedTradeConcern.imsId" class="symbol-link" v-bind:href="tradeConcernsDetailsUrl + '?imsId=' + relatedTradeConcern.imsId + '&domainId=' + relatedTradeConcern.domainId">STC {{ relatedTradeConcern.imsId }} ({{ relatedTradeConcern.domainId }})<span v-if="relatedTradeConcerns.length > 1 && relatedTradeConcerns.length -1 !== index">, </span></a>
          </div>
          <div v-else>
            <b-tooltip :label="relatedSpecificTradeConcerns" type="is-primary is-light" position="is-bottom" size="is-small" multilined>
              <a style="text-decoration: none" href="javascript:void(0)" @click="showViewNotification()"><b-icon pack="far" icon="comment-alt-exclamation" size="is-medium"></b-icon></a>
            </b-tooltip>
		  </div>
		</div>
	  </div>
	`,
});